import get from 'transmute/get';
export const getSenderField = get('senderField');
export const getActorId = get('actorId');
export const getDeliveryIdentifier = get('deliveryIdentifier');
export const getSenderName = get('name');